import { giphyLightestGrey } from '@giphy/colors'
import { useContext, useMemo } from 'react'
import IconComponent from 'ui/src/components/icon'
import { heightFromControlSize } from 'utils/src/control-size'
import { contentTypeFromGif, extendedContentTypeFromGif, iconFromContentType } from '../../../utilities/content-type'
import { METADATA_INFO_SIZE } from '../../constants'
import { EditPanelFieldContext } from '../../contexts/field'
import { EditPanelContext } from '../../contexts/panel'
import Field from '../../field'
import Radio from '../../field/inputs/searchable'
import { titleFromField } from '../../utilities/field'
import { hasFieldPermission } from '../../utilities/permissions'
import { Container, Item, Label } from './style'

const ICON_SIZE = heightFromControlSize(METADATA_INFO_SIZE)

type Props = {
    className?: string
    gifId: string
    metadata: any
}

const ContentTypes = ['sticker', 'text', 'emoji', 'genie'] as const
const EditPanelMetadataContent = ({ className, gifId, metadata }: Props) => {
    const { colors, gifs, permissions, isCompact } = useContext(EditPanelContext)
    const { changeField } = useContext(EditPanelFieldContext)
    const gif = useMemo(() => {
        return gifs.find((g) => g.id === gifId)
    }, [gifId, gifs])
    const contentType = gif ? contentTypeFromGif(gif) : undefined
    const extendedContenttype = gif ? extendedContentTypeFromGif(gif) : ''
    const canEditContentType = permissions.staff
    const canChange = extendedContenttype !== 'gif' && extendedContenttype !== 'clip'
    return (
        <Container className={className} isCompact={isCompact}>
            {!!contentType && (
                <Item>
                    <Label $color={colors.label}>Content Type</Label>
                    {iconFromContentType(contentType) && (
                        <IconComponent
                            color={colors.text}
                            height={ICON_SIZE}
                            icon={iconFromContentType(contentType)}
                            width={ICON_SIZE}
                        />
                    )}
                    {canChange && canEditContentType && (
                        <select
                            defaultValue={extendedContenttype.toLowerCase()}
                            style={{ padding: 10, backgroundColor: giphyLightestGrey, marginLeft: 2 }}
                            onChange={(e) => {
                                const value = e.currentTarget.value
                                changeField('content-type', value)
                            }}
                        >
                            {ContentTypes.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    )}
                </Item>
            )}
            {hasFieldPermission('indexed', permissions) && (
                <>
                    <Item>
                        <Label $color={colors.label}>{titleFromField('indexed')}</Label>
                        <Field field="indexed" gifId={gifId} size={METADATA_INFO_SIZE} />
                    </Item>

                    <Item>
                        <Label $color={colors.label}>{titleFromField('searchable')}</Label>
                        <Radio field="searchable" gifId={gifId} size="medium" metadata={metadata} />
                    </Item>
                </>
            )}
        </Container>
    )
}

export default EditPanelMetadataContent
